import { Component, EventEmitter, forwardRef, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { IADGroupMappingListModel, IADDisplayDataItem } from '../group-mapping-definitions';
import { RollupContentComponent } from '../../../../shared/rollup/rollup-content.component';

@Component({
    selector: 'fi-ad-integration-group-mapping-mappings-list',
    templateUrl: './mappings-list.component.html',
    standalone: false,
})
export class FiAdIntegrationGroupMappingMappingsListComponent {
    @Input() dataList: IADDisplayDataItem[];
    @Input() level: number = 0;
    @Input() parentDataItem?: IADGroupMappingListModel;
    @Input() sideOption;

    @ViewChildren(RollupContentComponent) childRollupContents: QueryList<RollupContentComponent>;
    @ViewChildren(forwardRef(() => FiAdIntegrationGroupMappingMappingsListComponent))
    childMappingsLists: QueryList<FiAdIntegrationGroupMappingMappingsListComponent>;

    @Output() onChanges = new EventEmitter();

    getNamePadding() {
        return this.level * 35 + 'px';
    }

    showChildrenClick($event: MouseEvent, rollupContent: RollupContentComponent) {
        $event.preventDefault();
        rollupContent.toggleContent();
    }

    itemTrackByFn(index, item: any) {
        return item.GroupGuid;
    }

    onTypeChange(item: IADGroupMappingListModel, childList: FiAdIntegrationGroupMappingMappingsListComponent) {
        const childrenMapped = childList.setType(item.ObjectType, item.ObjectId, item.ObjectName);
        this.onChanges.emit([item].concat(childrenMapped));
    }

    setType(objectType, objectId, objectName) {
        this.dataList.forEach((item) => {
            item.group.ObjectType = objectType;
            item.group.ObjectId = objectId;
            item.group.ObjectName = objectName;
        });

        const childrenMapped = this.childMappingsLists.reduce((prevValue, list) => {
            return prevValue.concat(list.setType(objectType, objectId, objectName));
        }, []);
        return [].concat(
            this.dataList.map((item) => item.group),
            childrenMapped,
        );
    }

    isSelectTypeLocked(dataItem: IADGroupMappingListModel, parentDataItem?: IADGroupMappingListModel) {
        // "select type" should be locked for editing when it set by parent group
        return (
            dataItem.ObjectType &&
            ((parentDataItem && !!parentDataItem.ObjectType) ||
                (dataItem.ParentGroups && dataItem.ParentGroups.some((item) => !!item.ObjectType)))
        );
    }

    childOnChanges($event) {
        this.onChanges.emit($event);
    }

    isShowSelectType(group) {
        return (
            !this.sideOption.filter ||
            (this.sideOption.filter && !this.sideOption.ObjectType && !group.ObjectType) ||
            (this.sideOption.filter && this.sideOption.ObjectType === group.ObjectType)
        );
    }
}
